module.exports = __webpack_public_path__ + "img/1.caafb9f1.png";